import React, { useEffect, useRef } from 'react';

export const ColorList = ({ onSelectColor, setShowColorList }) => {
  const colors = [
    { id: 'X', label: 'Unable to interpet', color: '#f0f0f0' },
    { id: '1', label: 'Normal', color: '#b7eb8f' },
    { id: '2', label: 'Hypokinetic', color: '#FFEA00' },
    { id: '3', label: 'Akinetic', color: '#FF5B61' },
    { id: '4', label: 'Dyskinetic', color: '#00008B' },
    { id: '5', label: 'Aneurysmal', color: '#9998a4' },
    { id: '6', label: 'Akinetic w/scar', color: '#ff0008' },
    { id: '7', label: 'Dyskinetic w/scar', color: '#0096FF' },
  ];

  const modalRef = useRef(null);

  const handleColorChange = data => {
    onSelectColor(data.color);
  };

  useEffect(() => {
    const handleClickOutside = event => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowColorList(false); // Close the modal if click is outside
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setShowColorList]);

  return (
    <div className="modal-overlay">
      <div
        className="color-list-container"
        ref={modalRef}
      >
        {colors.map((data, index) => (
          <div
            className="color-list-container-item"
            key={index}
            onClick={() => handleColorChange(data)}
          >
            <div className="w-2">{data.id}</div>
            <div
              style={{ backgroundColor: data.color }}
              className="color-dot"
            ></div>
            <span className="color-label">{data.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
